<template>
	<div>
		Home
	</div>
</template>
<script>
	export default 
	{
		created () 
		{
			document.title = "Bookplate";
		}
	}
</script>